import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { API_URL } from '../../services/api';
import { LetterData } from '../../types/letter';
import LetterPreview from './LetterPreview';

/**
 * Page dédiée Puppeteer — ticket JWT, sans auth session (fetch brut).
 */
const PrintLetterPage: React.FC = () => {
    const { letterId } = useParams<{ letterId: string }>();
    const [params] = useSearchParams();
    const ticket = params.get('ticket') || '';
    const [data, setData] = useState<LetterData | null>(null);
    const [error, setError] = useState('');
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!letterId || !ticket) {
            setError('Ticket manquant');
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(
                    `${API_URL}/letter/print-data?ticket=${encodeURIComponent(ticket)}`
                );
                if (!res.ok) {
                    const body = await res.json().catch(() => ({}));
                    throw new Error(body.error || `Erreur ${res.status}`);
                }
                const json = await res.json();
                if (cancelled) return;
                setData(json);
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        if (!cancelled) setReady(true);
                    }, 300);
                });
            } catch (e: any) {
                if (!cancelled) setError(e.message || 'Impossible de charger la lettre');
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [letterId, ticket]);

    if (error) {
        return (
            <div className="p-8 text-red-600" data-print-ready="false">
                {error}
            </div>
        );
    }

    if (!data) {
        return (
            <div className="p-8" data-print-ready="false">
                Chargement…
            </div>
        );
    }

    return (
        <div
            className="bg-white"
            data-print-ready={ready ? 'true' : 'false'}
            style={{ width: '210mm', minHeight: '297mm' }}
        >
            <LetterPreview data={data} />
        </div>
    );
};

export default PrintLetterPage;
